export default function addClass(el, classes) {
	if (!el) {
		return;
	}

	el.classList.add(classes);
}
